var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "egrul-records-table" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "tbody",
      _vm._l(_vm.records, function (r, i) {
        return _c("tr", { key: i }, [
          _c("td", [_vm._v(_vm._s(r.grn_date))]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(r.grn))]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(r.type))]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th", [_vm._v("ГРН")]),
        _vm._v(" "),
        _c("th", [_vm._v("Вид изменения")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }